/**
 *  @class
 *  @function ModalDialog
 */
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.hide();
        }
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  }
  customElements.define('modal-dialog', ModalDialog);

  if (!customElements.get('modal-vto')) {
    class ModalVTO extends ModalDialog {
      constructor() {
        super();

        this.configParameters = {
          apiKey: 'TjwkNHFqae7dbGldVHNt8zfLLAMuwJ9pt1wh35Hg',
            frame: '',
            onStopVto: () => {
            console.log('VTO experience has stopped');
          },
            onIssue : (data) => {
            console.log(data);
          }
        };
        this.fitmixInstance = null;
        this.sku = '';
        this.closeVTO = this.querySelector('.closeVTO');

        this.enableVTOButtons();
        this.init();
      }

      init() {
        console.log('Virtual Try On initiated');

        this.addEventListener("click", (event) => {
          if (event.target.nodeName === "MODAL-VTO") this.hide(); this.stopVTO();
        });

        this.closeVTO.addEventListener('click', () => {
          this.stopVTO();
        });

        this.createWidget();
      }

      enableVTOButtons() {
        let vtoButtons = document.querySelectorAll('.virtual-try-on');
        //console.log('vtoButtons:', vtoButtons);

        if (!vtoButtons.length) {return false}

        vtoButtons.forEach(button => {
          button.removeAttribute('disabled');

          button.addEventListener('click', (e) => {
            e.preventDefault();

            this.setID(button.dataset.sku);
            this.startVTO();
            this.show();
          });
        });
      }

      createWidget() {
        this.fitmixInstance = FitMix.createWidget(
          'fitmixContainer',
          this.configParameters,
          () => {
            console.log('fitmixInstance ready');
          });
      }

      setID(sku) {
        if (!sku) {return false}
        console.log('sku:', sku);

        this.configParameters.frame = sku;
        this.sku = sku;
        this.fitmixInstance.setFrame(`${sku}`);
      }

      startVTO() {
        this.fitmixInstance.startVto('live');
      }

      stopVTO() {
        this.fitmixInstance.stopVto();
      }
    }
    customElements.define("modal-vto", ModalVTO);
  }
}

if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
}

